export const BusinessInsuranceQuoteTestData = {
   
   /**
    * Step 0 data (Discovery and Contact)
    */
   discoveryType: 'Referrer',
   referrersName: 'Abigail Smith', // Left blank for this scenario
   contactOptions: ['Email', 'Phone'],
   discountCode: 'SUMMER25',
   
   contactEmail: 'alice.thompson@examplebiz.co.uk',
   contactPhone: '+442079460123',
   
   /**
    * Step 1 : Personal Data (Applicant)
    */
   title: 'Ms.',
   firstName: 'Alice',
   lastName: 'Thompson',
   birthDate: '1985-06-15',
   
   employmentStatus: 'Self-Employed',
   mainOccupation: 'Consultant',
   occupationIndustry: 'Financial Services',
   
   /**
    * Step 2 Data: Business and/or correspondent address
    */
   businessHouseNumber: '24',
   businessStreetAddress: 'Victoria Street',
   businessPostCode: 'SW1E 6QT', // London postcodes
   businessYearEstablished: '2019',
   
   // Assuming correspondent is the same as business address for simplicity
   correspondentHouseNumber: '24',
   correspondentStreetAddress: 'Victoria Street',
   correspondentPostCode: 'SW1E 6QT',
   
   /**
    * Step 3: Company info
    */
   previousInsurerName: 'Aviva',
   businessType: 'Limited Company',
   businessName: 'Thompson Business Consulting Ltd',
   businessCategory: 'Professional Services (Non-High Risk)',
   businessOtherCategory: '',
   businessEstablishmentDate: '2018-09-01',
   businessNumberOfEmployees: '3', // 2 directors, 1 employee
   businessEstimatedAnnualTurnover: '150000', // £150k
   businessEstimatedAnnualWages: '65000',
   
   /**
    * Step 4: Premises
    */
   businessPremiseLocation: 'Business Park',
   businessOpeningHours: '09:00 - 17:00',
   hasCcTvCameraInsidePremise: 'Yes',
   isThePremiseEntitledAsListedBuilding: 'No',
   premiseRoofType: 'Slope Roof',
   premiseFlooringType: 'Wooden Floor',
   premiseWallType: 'Brick Wall',
   doesAnyoneLiveUpStairs: 'No',
   whoLivesUpStairs: '', // N/A
   isBackDoorSecured: 'Yes',
   premiseOccupationTime: 'Unoccupied',
   hasRollerShuttersOnPremise: 'No',
   hasGrillsOnPremise: 'No',
   hasAlarmsOnPremise: 'Yes',
   premiseAlarmDetails: 'Redcare Monitored System',
   doesAlarmNotifyPolice: 'Yes',
   isPremiseAlarmCheckedRegularly: 'Yes',
   hasCommercialKitchenOnPremise: 'No',
   isRunningACaffeOrTakeAwayRestaurant: 'No',
   
   /**
    * Step 5 data (Coverage and Claims)
    */
   premiseTenureType: 'Leased', // Using the recommended "Property Status" option
   isBuildingCoverRequired: 'No', // Tenant does not usually require building cover
   maximumCashAmountToCoverOnBusinessHours: '1000',
   isCashAmountCoverRequiredOutsidePremise: 'No',
   
   // Stock/Contents to Insure (in GBP)
   tobaccoRelatedStockInsureAmount: '0',
   wineRelatedStockInsureAmount: '0',
   frozenItemRelatedStockInsureAmount: '0',
   furnitureRelatedStockInsureAmount: '8000', // Desks, chairs, filing
   electricalEquipmentRelatedStockInsureAmount: '4500', // PCs, printer, networking
   otherStockInsureAmount: '0',
   
   hadAnyClaimsBeenMadeInLast5Years: 'No',
   
   isExemptFromPayingPAYE: 'No',
   employerReferenceNumber: '123/AB4567',
   
   policyStartDate: '2026-01-01',
   
   addAdditionalComments: 'Standard business consultancy, no client visits, minimal cash held on premises.',
   
   termsAgreement: 'Yes',
};
